import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { getMonth, getYear,format } from 'date-fns';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import {userGroupUrlCheck, getUserTimeZone} from '../../utils/userGroupUrlCheck';
import {URL_IMG} from '../../configs/urlConfigs';
import {ROUTE_REFRESH, ROUTE_AFFILIATE_REFRESH, ROUTE_CLIENT_REFRESH, PAGENUMROWS_SCHEDULE_CREW_VIEW,LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP, ROUTE_AFFILIATE_SCHEDULE_SHIFT,SCHEDULE_CREW_STATUS,SHIFT_STATUS,RANDOM_COLORS,CREW_MAX_RATING} from '../../configs/staticConfigs'; 
import{ MSG_SERVER_DATA_FETCH_ERROR,MSG_NOT_FOUND } from '../../configs/msgConfigs';
import { LBL_APP_NAME, LBL_SCHEDULE_SHIFT,LBL_HOURS_SHORT, LBL_DATE_VIEW, LBL_CREW_VIEW, LBL_REQUIRED, LBL_REQUESTED, LBL_ON, LBL_EVENT_TITLE, LBL_SHIFT_TITLE, LBL_FILTER, LBL_CLEAR_FILTERS, LBL_TOTAL, LBL_CONFIRMED, LBL_CREW_NAME,LBL_SCHED_VIEW_SUB_SEARCH, LBL_SEARCHING,LBL_FROM,LBL_TO,LBL_SHIFTS_IN } from '../../configs/labelConfigs';  

import { schedulesDateViewCalendarAction, scheduleCrewViewAction, sendShiftIdsForScheduleAction, scheduleSetHeaderFromToDateAction, schedDateViewCalendarDateAction } from '../../actions/eventActions';
import {aflt_departmentsListAction} from '../../actions/settings/affiliates/aflt_departmentActions';
import {clearAction, serverTimeAction,fromReport} from '../../actions/commonActions';
import * as types from '../../actions';

// import {getPrevDate} from '../../utils/commonUtilities'; 

//import { getUserGroupData } from '../../utils/browserStorage';
import { converDateToLocal,convertDecimalToHHMM } from '../../utils/commonUtilities';

//import ModalWindow from '../commons/helpers/modalWindow';
//import Paginator from '../commons/helpers/paginator';
import Toast from '../commons/helpers/toast';
import Filter from '../commons/helpers/filterBy';
//import FilterShift from './filters/filterShift';

import ShiftDetailSlider from './shiftDetailSlider';
import FilterScheduleView from './filters/filterScheduleView';

const localizer = momentLocalizer(moment)

const CustomEvent = (event) => { 
    return ( 
      <div className="div-cal-date"><span className="number-circle"> {event.title} </span></div> 
    ) 
  }

class ScheduleView extends Component {

    constructor(props){
        super()
        this.state = {
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true, 
            searchSchedule:'',
            formErrors:{
            },
            scheduleData_Date:[],   
            scheduleData_Date_Rows: [],
            scheduleData_Crew:{},  
            scheduleData_Crew_Rows: [],        
            userGroup: 0,
            dataViewType: 'date', // date/crew
            isClientPage: false,
            rand :Math.floor(Math.random()*RANDOM_COLORS.length),
            activeShiftId: 0,
            eventDataForShift:{
                eventId:'',
                eventTitle:'',
                clientId:'',
                affiliateId:'',
                location:'',                
                venueName:"",
                streetOne:"",
                streetTwo:"",
                city:"",
                state:"",
                country:"",
                postcode:"",
                startDate:"",
                endDate:"",
            },
            pageSize: PAGENUMROWS_SCHEDULE_CREW_VIEW,
            hasMore:false,
            currentPage: 1,
            nextPage: 1,
            columnName: 'crew__user__first_name',
            dateView_hasMore:false,
            dateView_currentPage: 1,
            dateView_nextPage: 1,
            dateView_columnName: 'crew__user__first_name',
            applyFilter: 0,
            filterClicked: 0,
            resetFilterClicked: 0,
            applyFilterClicked: 0,
            isFilterOn: false,
            filtersData: {},
            msgDataNotFound: '',
            selectedDate:'',
            curMonth: 0,
            curYear: 0,
            dateViewCalendarData: [], 
            searchDateView : '',
            tabSwitch : 0,
            tabCurrentlySwitched : true,
            tabSwitchingStatus : false,
            defaultStartDate : new Date()
        }

        // this.onShowActionButtons = this.onShowActionButtons.bind(this);
    } 

    callDateViewCalendar = () => {
        if(this.state.curMonth && this.state.curYear){
            let searchStr = this.state.searchSchedule.length > 2 ? this.state.searchSchedule : '';
            let dataObj = { search:encodeURIComponent(searchStr), column:this.state.dateView_columnName, page: this.state.dateView_nextPage, pageSize: this.state.pageSize, applyFilter:this.state.applyFilter, filtersData:this.state.filtersData, month:this.state.curMonth, year:this.state.curYear };
            this.props.schedulesDateViewCalendarAction(dataObj);
        }
         
    }

    formatCalendarData = (arrData) => {
        let timeZone =  getUserTimeZone(this.props.location);
        let todayDateTmp = format(this.state.defaultStartDate,'yyyy-MM-dd');  
        let callLoadToday = false; 
        let calendarData = [];
        if(arrData.length>0){
            let dataObj = {};  
            let loadDateVal = ''; 
            
            arrData.forEach(item => {
                dataObj = {};  
                dataObj['id'] = Number(item.date);
                dataObj['title'] = item.count;       
                dataObj['start'] = item.date;  
                dataObj['end'] = item.date;  
                // dataObj['numSchedules'] = Number(item.count);
                calendarData.push(dataObj);
                // IF selectedDate IS BLANK, LOAD TODAYS SCHEDULE DETAILS BY DEFAULT IF THERE ANY SCHEDULES TODAY,
                // IF selectedDate HAVE DATA, LOAD selectedDates' SCHEDULE DETAILS, IF THERE ANY SCHEDULES ON selectedDate
                if(this.state.selectedDate=='' && todayDateTmp==item.date && parseInt(item.count) > 0) {
                    callLoadToday = true; 
                }
                else if(this.state.selectedDate!='' && format(new Date(this.state.selectedDate),"yyyy-MM-dd")==item.date && parseInt(item.count) > 0) {
                    loadDateVal = item.date;
                }
            });   
            
            this.setState({dateViewCalendarData:calendarData,selectedDate:'',scheduleData_Date:[]}); 

            if(callLoadToday) {
                this.onDateSelection({id:null,title:'',start:todayDateTmp,end:todayDateTmp});
            } 
            else if(loadDateVal!='') {
                this.onDateSelection({id:null,title:'',start:loadDateVal,end:loadDateVal});
            }  
        }
        else {
            this.setState({dateViewCalendarData:calendarData,selectedDate:'',scheduleData_Date:[]}); 
        }
    }

    onDateSelection = (dateVal)=>{
        let dateSelected = format(new Date(dateVal.start),"yyyy-MM-dd");
        this.setState({selectedDate:new Date(dateVal.start),searchDateView:''}, () => {
            let searchStr = this.state.searchSchedule.length > 2 ? this.state.searchSchedule : '';
            let dataObj = { search:encodeURIComponent(searchStr), column:this.state.dateView_columnName, page: this.state.dateView_nextPage, pageSize: this.state.pageSize, applyFilter:this.state.applyFilter, filtersData:this.state.filtersData, selDate:dateSelected };
            this.props.schedDateViewCalendarDateAction(dataObj); 
        });
    } 

    setSubTitle = () => {

        let prevDateString = ''; 
        if(this.state.dataViewType=='crew' && this.state.applyFilter && Number(this.state.applyFilter) > 0 && this.state.filtersData.selectedStartDate.length > 0 && this.state.filtersData.selectedEndDate.length > 0) {
            let arrDt = this.state.filtersData.selectedStartDate.split('-');
            let arrDtTo = this.state.filtersData.selectedEndDate.split('-')
            prevDateString = ' (Shifts from '+arrDt[2]+'/'+arrDt[1]+'/'+arrDt[0]+' to '+arrDtTo[2]+'/'+arrDtTo[1]+'/'+arrDtTo[0]+') ';  
        }
        else {
            // prevDateString = ' (Shifts from '+getPrevDate(5,'/')+' to '+getPrevDate(0,'/')+') ';
            prevDateString = '';
        } 
        this.props.scheduleSetHeaderFromToDateAction(prevDateString);  
    }

    onShowFilterBy = () => {
        let filterClicked = (this.state.filterClicked+1);
        this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn, filterClicked:filterClicked }));
        document.getElementById("filterByMenu").classList.toggle('active');      
        document.getElementById("filterIcon").classList.toggle('active');   
        let filterByMenu = document.getElementById('filterByMenu');    
        let quoteTab = document.getElementById('detailTab');
        let filterTab = document.getElementById('filterTab');
        quoteTab.style.display = 'none';    
        filterTab.style.display = 'block';        
        if(this.state.isFilterOn){
            filterByMenu.style.width='580px';
            filterByMenu.style.right='-580px';
        }else{
            filterByMenu.style.width='580px';
            filterByMenu.style.right='0';
        }
    }

    onResetFiltersButton = () => {   
        let resetFilterClicked = this.state.resetFilterClicked+1; 
        if(this.state.applyFilter > 0) {
            this.setState({resetFilterClicked,applyFilter:0,filtersData: {}, currentPage: 1, nextPage:1,  hasMore:false, dateView_hasMore:false, dateView_currentPage:1, dateView_nextPage:1 }, () => { 
                let searchStr = ''; // this.state.searchSchedule.length > 2 ? this.state.searchSchedule : '';
                if(this.state.dataViewType==='date') {
                    this.callDateViewCalendar(); 
                }
                else if(this.state.dataViewType==='crew') { 
                    let dataObj = { search:searchStr, column:this.state.columnName, page: 1, pageSize: this.state.pageSize, applyFilter:this.state.applyFilter, filtersData:this.state.filtersData }; 
                    this.props.scheduleCrewViewAction(dataObj); 
                }
                if(this.state.isFilterOn) {
                    document.getElementById("filterIcon").classList.add('active');   
                }
                else if(!this.state.isFilterOn) {
                    document.getElementById("filterIcon").classList.remove('active');   
                }
            });
        }
        else {
            this.setState({resetFilterClicked,applyFilter:0}); 
        }
    }

    changeTabSwitchedStatus = (value) =>{
        this.setState({tabCurrentlySwitched:value});
    }

    onApplyFilterButton = () => {
        let applyFilterClicked = this.state.applyFilterClicked+1; 
        this.setState({applyFilterClicked}); 
    }

    applyFilters = (filtersData) => {
        // RESET ALL LISTING VALUES TO DEFAULT AND ADD FILTER FLAG AND FILTER DATA 
        let applyFilter = 0; 
        if(filtersData.filtersSelected > 0) applyFilter = 1; 
        this.setState({applyFilter:applyFilter, filtersData:filtersData, currentPage:1, nextPage:1, hasMore:false, dateView_hasMore:false, dateView_currentPage:1, dateView_nextPage:1 }, () => {   
            let searchStr = this.state.searchSchedule.length > 2 ? this.state.searchSchedule : '';
            if(this.state.dataViewType==='date') {
                this.callDateViewCalendar(); 
            }
            else if(this.state.dataViewType==='crew') { 
                let dataObj = { search:encodeURIComponent(searchStr), column:this.state.columnName, page: 1, pageSize: this.state.pageSize, applyFilter:this.state.applyFilter, filtersData:this.state.filtersData }; 
                this.props.scheduleCrewViewAction(dataObj); 
            }
        }); 
    } 
    
    onSearchString = (e)=>{
        let searchStr = e.target.value; 
        this.setState({searchSchedule:searchStr, currentPage:1, nextPage:1, hasMore:false, dateView_hasMore:false, dateView_currentPage:1, dateView_nextPage:1}, () => { 
            // if((searchStr.length===0 || searchStr.length > 2) && this.state.dataViewType==='date') {
            //     this.callDateViewCalendar(); 
            // } else 
            if((searchStr.length===0 || searchStr.length > 2) && this.state.dataViewType==='crew') {
                let dataObj =  { search:encodeURIComponent(searchStr), column: this.state.columnName, page: 1, pageSize: this.state.pageSize, applyFilter:this.state.applyFilter, filtersData:this.state.filtersData }; 
                this.props.scheduleCrewViewAction(dataObj); 
            }
        });
    }

    onDateViewSearch = (e)=>{
        this.setState({searchDateView:e.target.value}); 
   }

    loadNextPage = () => {
        let searchStr = this.state.searchSchedule.length > 2 ? this.state.searchSchedule : '';
        if(this.state.dataViewType==='date') {
            this.callDateViewCalendar(); 
        }
        else if(this.state.dataViewType==='crew') {
            let dataObj =  { search:encodeURIComponent(searchStr), column: this.state.columnName, page: this.state.nextPage, pageSize: this.state.pageSize, applyFilter:this.state.applyFilter, filtersData:this.state.filtersData }; 
            this.props.scheduleCrewViewAction(dataObj); 
        }
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
    } 

    changeTabState = (value) =>{
      
      let status = false;
      if(value == 0){
        status = true
      }
      this.setState({tabSwitch:value,tabCurrentlySwitched:status,tabSwitchingStatus:false}); 
    }
    tabSwitchCompleted = (value) =>{
        this.setState({tabSwitchingStatus:value});
    }

    changeViewType = (e, viewType) => {
        let resetFilterClicked = 0; 
        // let searchStr = this.state.searchSchedule.length > 2 ? this.state.searchSchedule : '';
        if(viewType==='date' && this.state.dataViewType!=='date') {
            this.setState({resetFilterClicked, dataViewType:'date', searchSchedule:'', applyFilter:0, filtersData: {}, currentPage:1, nextPage:1, hasMore:false, dateView_hasMore:false, dateView_currentPage:1, dateView_nextPage:1,msgDataNotFound:''}, () => {
                this.callDateViewCalendar(); 
            });
           this.changeTabState(0);  
        }
        else if(viewType==='crew' && this.state.dataViewType!=='crew') {
            this.setState({resetFilterClicked, searchSchedule:'', dataViewType:'crew', applyFilter:0, filtersData: {}, currentPage:1, nextPage:1, hasMore:false, dateView_hasMore:false, dateView_currentPage:1, dateView_nextPage:1,msgDataNotFound:''}, () => {
                let dataObj = {search:encodeURIComponent(this.state.searchSchedule), column: this.state.columnName, page: 1, pageSize: this.state.pageSize, applyFilter:this.state.applyFilter, filtersData:this.state.filtersData};  
                // this.props.scheduleCrewViewAction(dataObj); 
            });
            this.changeTabState(1); 
        } 
    }

    showShiftDetail = (shiftId) =>{
        document.getElementById("filterByMenu").classList.toggle('active');    
        let filterByMenu = document.getElementById('filterByMenu');  
        let quoteTab = document.getElementById('detailTab');
        let filterTab = document.getElementById('filterTab');
        quoteTab.style.display = 'block';    
        filterTab.style.display = 'none';
        filterByMenu.style.width='1100px';
        filterByMenu.style.right='0';
        this.setState({activeShiftId:shiftId});
    }

    loadEventSchedule = (eventId,shiftDetails) => { 
        if(shiftDetails) {
            // SKILLS NEED TO BE CONVERTED INTO OTHER FORMAT 
            // "shift_skills":[{"id":4286,"skill_id":1306,"skill_name":"General","required":2,"requested":0,"assigned":0,"rejected":0,"pending":2}]
            // "shift_skills":[{"id":4225,"skill":{"id":1306,"skill_name":"General","is_active":true,"index":1,"affiliate":210},"scheduled":false,"pending":12,"chiefs_pending":3,"count":12,"requested":1,"assigned":0,"rejected":0,"chiefs_required":3,"chiefs_requested":0,"chiefs_accepted":0,"chiefs_rejected":0},
            let allSkills = [];
            shiftDetails.shift_skills.forEach(item => {
                allSkills.push({id:item.id, skill:{id:item.skill_id,skill_name:item.skill_name}, pending:item.pending, requested:item.requested, assigned:item.assigned, rejected:item.rejected, chiefs_pending:item.chiefs_pending?item.chiefs_pending:0, chiefs_required:item.chiefs_required?item.chiefs_required:0, chiefs_requested:item.chiefs_requested?item.chiefs_requested:0, chiefs_accepted:item.chiefs_accepted?item.chiefs_accepted:0,chiefs_rejected:item.chiefs_rejected?item.chiefs_rejected:0 }); 
            })
            
            let shiftItems = [{
                start_datetime:shiftDetails.start_datetime,
                end_datetime:shiftDetails.start_datetime,
                skills:allSkills,
                shiftId:shiftDetails.shift_id,
                chiefsRequired:shiftDetails.chiefs_required,
                chiefsPending:shiftDetails.chiefs_pending,
                isAllChecked:false,
                status:shiftDetails.status,
                department:shiftDetails.department!==null?shiftDetails.department:''              
            }];

            this.props.sendShiftIdsForScheduleAction(shiftItems);
            this.props.history.push(ROUTE_AFFILIATE_SCHEDULE_SHIFT+'/'+eventId);
        }
        else {
            this.props.history.push(ROUTE_AFFILIATE_SCHEDULE_SHIFT+'/'+eventId);
        }
    }

    customToolbar = (toolbar) =>{
        return (
          <div className="rbc-toolbar">          
            <span className="rbc-toolbar-label">{LBL_SHIFTS_IN+' '+toolbar.label}</span>
            <span className="rbc-btn-group">
              <button onClick={()=>this.goToBack(toolbar)}><i className="fa fa-angle-left"></i></button>
              <button onClick={()=>this.goToNext(toolbar)}><i className="fa fa-angle-right"></i></button>
            </span>
          </div>      
        )
    }   

    goToBack = (toolbar) => {
        let {searchCrew} = this.state;
        toolbar.date.setMonth(toolbar.date.getMonth() - 1);
        let month= format(toolbar.date,'M');
        toolbar.onNavigate('prev');
        this.setState({curMonth:month,curYear:toolbar.date.getFullYear()}, () => {
            this.callDateViewCalendar(); 
        });
     }
    
     goToNext = (toolbar) => {
        let {searchCrew} = this.state;
        toolbar.date.setMonth(toolbar.date.getMonth() + 1);
        let month= format(toolbar.date,'M');
        toolbar.onNavigate('next');
        this.setState({curMonth:month,curYear:toolbar.date.getFullYear()}, () => {
            this.callDateViewCalendar(); 
        });
     }


    componentDidMount() {
        this.props.serverTimeAction();
        this.props.aflt_departmentsListAction({associated:'1'});
        let searchStr = this.state.searchSchedule.length > 2 ? this.state.searchSchedule : '';
        let month = getMonth(new Date())+1;
        let year  = getYear(new Date()); 
        if(this.props.isFromReport){
                this.setState({dataViewType:'crew',tabSwitch:1, tabSwitchingStatus:false,curMonth:month,curYear:year})
        }else{
                this.setState({curMonth:month,curYear:year,dataViewType:'date'})
                this.callDateViewCalendar();
        }
        const { location } = this.props; 
   
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = '';
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }   
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
            this.setState({isClientPage:false});            
        }else if(userGroup===LOGIN_CLIENT_GROUP){
            document.body.classList.add('body-client'); 
            this.setState({isClientPage:true});
        }
        document.title = LBL_APP_NAME+" - "+LBL_SCHEDULE_SHIFT;
    }

    componentDidUpdate(prevProps) {
        const {isFilterOn,status,activity,subactivity,schedDateViewCalendarData,schedDateViewCalDateData} = this.props;
        if(this.props.serverTimeListActivity && this.props.serverTimeListActivity !== prevProps.serverTimeListActivity){
            let arrTimeResp = this.props.serverTimeListActivity.split('~~');
            if(arrTimeResp[0]===types.SERVER_TIME_LIST_SUCCESS){
                // let defaultStartDate = new Date(this.props.serverTimeList.current_date+" 00:00:00");
                let defaultStartDate = new Date(this.props.serverTimeList.current_date+"T00:00:00");
                this.setState({defaultStartDate:defaultStartDate})
            }
        }
        if (isFilterOn !== prevProps.isFilterOn) {
            this.inputFilter.click();   
        }

          
        if (subactivity && subactivity !== prevProps.subactivity) {
            let arrResponse = subactivity.split('~~'); 
            if(arrResponse[0]===types.SCHEDULE_DATE_VIEW_CALENDAR_SUCCESS){
                this.setSubTitle();
                if(status===200) {
                    this.formatCalendarData(schedDateViewCalendarData.data); 
                }
                else {
                    let arrEmpty = []; 
                    this.formatCalendarData(arrEmpty); 
                    this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_SERVER_DATA_FETCH_ERROR}); 
                    setTimeout(()=> { this.onCloseToast(); }, 5000);
                }
            }
            else if(arrResponse[0]===types.SCHEDULE_DATE_VIEW_CALENDAR_ERROR){
                this.setSubTitle();
                let arrEmpty = []; 
                this.formatCalendarData(arrEmpty); 
                this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_SERVER_DATA_FETCH_ERROR}); 
                setTimeout(()=> { this.onCloseToast(); }, 5000);
            }
            else if(arrResponse[0]===types.SCHED_DATE_VIEW_CALENDAR_DATE_SUCCESS){
                this.setSubTitle();
                if(status===200) {
                    this.setState({scheduleData_Date:schedDateViewCalDateData.data}); 
                }
                else {
                    this.setState({scheduleData_Date:[],toastSuccess:false, toastFlag:true, toastMessage:MSG_SERVER_DATA_FETCH_ERROR}); 
                    setTimeout(()=> { this.onCloseToast(); }, 5000);
                }
            }
            else if(arrResponse[0]===types.SCHED_DATE_VIEW_CALENDAR_DATE_ERROR){
                this.setSubTitle();
                this.setState({scheduleData_Date:[],toastSuccess:false, toastFlag:true, toastMessage:MSG_SERVER_DATA_FETCH_ERROR}); 
                setTimeout(()=> { this.onCloseToast(); }, 5000);
            }
        } // 

        if (activity && activity !== prevProps.activity) {
            let errorMsg = '';  
            let arrResp = activity.split('~~'); 
            let actString = arrResp[0]; 

            let hasMore = false; 
            let currentPage = this.state.currentPage; 
            let nextPage    = this.state.nextPage; 
            
            let dateView_hasMore     = false; 
            let dateView_currentPage = this.state.dateView_currentPage; 
            let dateView_nextPage    = this.state.dateView_nextPage; 
            
            if(actString===types.SCHEDULE_DATE_VIEW_SUCCESS){
                this.setSubTitle(); 
                if(status===200) {
                    let dateData = []; 
                    if(this.props.hasOwnProperty('scheduleDateViewData') && this.props.scheduleDateViewData.hasOwnProperty('results')) {
                        dateData = this.props.scheduleDateViewData.results; 

                        // links - FOR PAGINATION, next & prev NOT USED FOR THIS API, APPLY PAGINATION USING current_page and count
                        if(this.props.scheduleDateViewData.links.current_page && Number(this.props.scheduleDateViewData.links.current_page) > 0) {
                            dateView_currentPage = this.props.scheduleDateViewData.links.current_page;
                        }

                        if(this.props.scheduleDateViewData.count && this.props.scheduleDateViewData.links.current_page && this.props.scheduleDateViewData.page_size && Number(this.props.scheduleDateViewData.count) > (Number(this.props.scheduleDateViewData.links.current_page)*Number(this.props.scheduleDateViewData.page_size))) {
                            dateView_hasMore = true; 
                            dateView_nextPage++; 
                        }
                    }

                    let fullDataRows = (dateView_currentPage===1) ? dateData : [...this.state.scheduleData_Date_Rows, ...dateData]; 
                    this.setState({scheduleData_Date:fullDataRows, scheduleData_Date_Rows:fullDataRows, dateView_hasMore:dateView_hasMore, dateView_currentPage:dateView_currentPage, dateView_nextPage:dateView_nextPage}, () => {
                        let msgDataNotFound = this.state.scheduleData_Date_Rows.length===0 ? MSG_NOT_FOUND : ''; 
                        this.setState({msgDataNotFound:msgDataNotFound});
                    }); 
                }
                else {
                    errorMsg = '';  
                    // if(this.props.hasOwnProperty('errorData') && (this.props.errorData)) {
                    //    errorMsg = (this.props.errorData.hasOwnProperty('message')) ? ' - '+this.props.errorData.message : ''; 
                    // } 
                    this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_SERVER_DATA_FETCH_ERROR,dateView_hasMore:dateView_hasMore, dateView_nextPage:dateView_nextPage, dateView_currentPage:dateView_currentPage}); 
                    setTimeout(()=> { this.onCloseToast(); }, 5000);
                } 
            }
            else if(actString===types.SCHEDULE_DATE_VIEW_ERROR){ 
                this.setSubTitle(); 
                errorMsg = '';  
                // if(this.props.hasOwnProperty('errorData') && (this.props.errorData)) {
                //     errorMsg = (this.props.errorData.hasOwnProperty('message')) ? ' - '+this.props.errorData.message : ''; 
                // } 
                this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_SERVER_DATA_FETCH_ERROR,dateView_hasMore:dateView_hasMore, dateView_nextPage:dateView_nextPage, dateView_currentPage:dateView_currentPage}); 
                setTimeout(()=> { this.onCloseToast(); }, 5000);
            }

            
            if(actString===types.SCHEDULE_CREW_VIEW_SUCCESS){
                this.setSubTitle(); 
                if(status===200) {
                    let crewData = []; 
                    // {"links":{"next":null,"previous":null,"current_page":1},"count":1,"page_size":10,
                    if(this.props.scheduleCrewViewData.hasOwnProperty('results')) {
                        crewData = this.props.scheduleCrewViewData.results;
                        
                        // links - FOR PAGINATION, next & prev NOT USED FOR THIS API, APPLY PAGINATION USING current_page and count
                        if(this.props.scheduleCrewViewData.links.current_page && Number(this.props.scheduleCrewViewData.links.current_page) > 0) {
                            currentPage = this.props.scheduleCrewViewData.links.current_page;
                        }
                        
                        if(this.props.scheduleCrewViewData.count && this.props.scheduleCrewViewData.links.current_page && this.props.scheduleCrewViewData.page_size && (Number(this.props.scheduleCrewViewData.count) > (Number(this.props.scheduleCrewViewData.links.current_page)*Number(this.props.scheduleCrewViewData.page_size)))) {
                            hasMore = true; 
                            nextPage++; 
                        }
                    }

                    let fullDataRows = (currentPage===1) ? crewData : [...this.state.scheduleData_Crew_Rows, ...crewData]; 
                    this.setState({scheduleData_Crew:fullDataRows, scheduleData_Crew_Rows:fullDataRows, hasMore:hasMore, currentPage:currentPage, nextPage:nextPage}, () => {
                        let msgDataNotFound = (this.state.scheduleData_Crew_Rows.length===0 && crewData.length===0) ? MSG_NOT_FOUND : ''; 
                        this.setState({msgDataNotFound:msgDataNotFound}); 
                    }); 
                }
                else {
                    errorMsg = '';  
                    // if(this.props.hasOwnProperty('errorData') && (this.props.errorData)) {
                    //    errorMsg = (this.props.errorData.hasOwnProperty('message')) ? ' - '+this.props.errorData.message : ''; 
                    // } 
                    this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_SERVER_DATA_FETCH_ERROR, hasMore:hasMore, currentPage:currentPage, nextPage:nextPage}); 
                    setTimeout(()=> { this.onCloseToast(); }, 5000);
                } 
            }
            else if(actString===types.SCHEDULE_CREW_VIEW_ERROR){
                this.setSubTitle(); 
                errorMsg = '';  
                // if(this.props.hasOwnProperty('errorData') && (this.props.errorData)) {
                //     errorMsg = (this.props.errorData.hasOwnProperty('message')) ? ' - '+this.props.errorData.message : ''; 
                // } 
                this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_SERVER_DATA_FETCH_ERROR, hasMore:hasMore, currentPage:currentPage, nextPage:nextPage}); 
                setTimeout(()=> { this.onCloseToast(); }, 5000);
            }

        }
    }
   
    render(){

      const { toastMessage,toastFlag,toastSuccess,scheduleData_Date,rand,scheduleData_Crew_Rows,dataViewType,hasMore,dateView_hasMore,searchSchedule,msgDataNotFound,selectedDate,dateViewCalendarData,searchDateView } = this.state; 
      const { status } = this.props;   
      //let events = []; 
      let userGroupData = userGroupUrlCheck(this.props.location);
      let userGroup = ''; 
      if(userGroupData!==undefined){
         userGroup = userGroupData.user_group; 
      }

    if(status===401 || status===403){
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
        }else if(userGroup===LOGIN_CLIENT_GROUP){
            return <Redirect to={ROUTE_CLIENT_REFRESH} />;
        }else{
            return <Redirect to={ROUTE_REFRESH} />;
        }
    }

    //const dateOptions = { weekday: 'short', month: 'short', day: 'numeric' };
    //const timeOptions = { hour: 'numeric', minute: 'numeric', hour12: false };
    let timeZone = getUserTimeZone(this.props.location); 
    let todayDate = this.state.defaultStartDate;    
    let formattedCrews = [];

    let headerDate = '';
    let day = '';
    if(selectedDate===''){
        headerDate = converDateToLocal(todayDate,"+00:00",'MonthdayYear','-');
        day = 'Today';
    }else{
        headerDate = format(new Date(selectedDate),'MMM dd yyyy');
        let currentDateObj = this.state.defaultStartDate;
        day = format(currentDateObj,'YYY/MM/dd')===format(selectedDate,'YYY/MM/dd')?'Today':format(new Date(selectedDate),'EEEE');     

    }

    return(
        <React.Fragment>
            <div className="col-md-12">
               <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />

               <div className="box schedule-page"> 
                    <div className="box-head">
                        <div className="dataTables_filter">
                            {dataViewType==='crew' && <label>
                                <input type="search" className="" placeholder={dataViewType==='date' ?LBL_EVENT_TITLE+'/'+LBL_SHIFT_TITLE : LBL_CREW_NAME} id="my-search-input" onChange={this.onSearchString} value={searchSchedule} />
                                </label> }
                            {/* <div className="btn-group btn-group-sm">
                                <button type="button" className={dataViewType==='date' ? "btn btn-primary active" : "btn btn-outline-primary" } onClick={(e) => this.changeViewType(e,'date')} >{LBL_DATE_VIEW}</button>
                                <button type="button" className={dataViewType==='crew' ? "btn btn-primary active" : "btn btn-outline-primary" } onClick={(e) => this.changeViewType(e,'crew')} >{LBL_CREW_VIEW}</button>
                            </div>  */}
                        </div>

                        <div  className={this.state.applyFilter ? 'filter-btn-wrapper  text-primary-filter':'filter-btn-wrapper text-primary'}>
                            <OverlayTrigger placement="top" delay={{ show: 450, hide: 250 }} overlay={<Tooltip id="filterIcon-tooltip" style={{ opacity: 0.4, }}> {LBL_FILTER} </Tooltip>} >
                                <button id="filterIcon" ref={input => this.inputFilter = input} onClick={this.onShowFilterBy} className={this.state.applyFilter ? 'filter-btn  text-primary-filter':'filter-btn text-primary'}><i className="las la-filter"></i></button>
                            </OverlayTrigger>
                        </div>
                        {this.state.applyFilter > 0 && 
                        <div className="text-12 div150" onClick={this.onResetFiltersButton} >&nbsp; &nbsp; <Link to="#" >{LBL_CLEAR_FILTERS}</Link></div>} 

                        <div className="btn-group btn-group-sm to-right">
                            <button type="button" className={dataViewType==='date' ? "btn btn-primary active" : "btn btn-outline-primary" } onClick={(e) => this.changeViewType(e,'date')} >{LBL_DATE_VIEW}</button>
                            <button type="button" className={dataViewType==='crew' ? "btn btn-primary active" : "btn btn-outline-primary" } onClick={(e) => this.changeViewType(e,'crew')} >{LBL_CREW_VIEW}</button>
                        </div> 

                    </div>
                    <div className="box-content">
                        {msgDataNotFound.length > 1 && <div className="row text13 normalText paddingLeft15  d-flex justify-content-center align-items-center text-center"><label>{msgDataNotFound}</label></div>}



                        {dataViewType==='date' && 
                        <>

                        <div className="row">
                            <div className="col-md-8 schedule-date-view"> 
                                <Calendar
                                    localizer={localizer}
                                    views={['month']}
                                    defaultView = "month"
                                    defaultDate = {this.state.defaultStartDate}
                                    getNow={() => todayDate}
                                    components={{
                                    toolbar: this.customToolbar,
                                    event: CustomEvent,
                                    }}
                                    events={dateViewCalendarData}
                                    startAccessor="start"
                                    endAccessor="end"
                                    style={{ height: 600 }}
                                    popup={true}
                                    selectable={true}
                                    eventPropGetter={this.eventStyleGetter}
                                    onSelectEvent={event => this.onDateSelection(event)}
                                />
                            </div>
                           <div className="col-md-4 pt-2">
                                {scheduleData_Date.length > 0 && <>
                                <div className="dataTables_filter">
                                    {/* <AsyncTypeahead
                                       isLoading={false}
                                       name="name" 
                                       id="crewSearch"
                                       minLength={3}
                                       labelKey="name"
                                       onChange={selected => this.onSelectCrew(selected)}
                                       options={formattedCrews}
                                       placeholder={LBL_SCHED_VIEW_SUB_SEARCH}
                                       onSearch={this.onSearchCrew}
                                       searchText={LBL_SEARCHING}
                                       promptText={LBL_SCHED_VIEW_SUB_SEARCH}
                                    /> */}
                                    <input type="search" className="" placeholder={LBL_SCHED_VIEW_SUB_SEARCH} id="sub-search-input" onChange={this.onDateViewSearch} value={searchDateView} />
                              </div>
                              <div className="pt-5 mb-3 unavail-head">
                                 <span>{day} - {headerDate}</span>
                              </div></>}
                              
                              {scheduleData_Date.length > 0 &&                             
                                <div className="row">
                                    <div className="col-md-12 padding-left-0 ">
                                        {scheduleData_Date.map((shiftDet, index) => { 
                                            let showShift = 1; 
                                            let eventShiftTitles = ''; 
                                            let tmpSearchStr = ''; 
                                            if(searchDateView.length > 0) {
                                                tmpSearchStr = searchDateView.toLowerCase(); 
                                                eventShiftTitles = (shiftDet.shift_title+' '+shiftDet.event_title).toLowerCase();
                                                if(!eventShiftTitles.includes(tmpSearchStr)) showShift = 0; 
                                            }

                                            const shiftStatus = SHIFT_STATUS.filter(x => Number(x.statusCode)===Number(shiftDet.status));
                                            
                                            let arrDt = []; 
                                            let arrDMY = []; 
                                            // arrDt = shiftDet.start_datetime.toString().split('T');
                                            // arrDt = shiftDet.start_datetime.toString().split('T');
                                            // const startHHMM = arrDt[1].substring(0,5);
                                            // arrDt = shiftDet.end_datetime.toString().split('T');
                                            // const endHHMM = arrDt[1].substring(0,5);

                                            let startDTime = converDateToLocal(shiftDet.start_datetime,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                                            arrDt = startDTime.toString().split(' ');
                                            const startHHMM = arrDt[1];
                                            let endDTime = converDateToLocal(shiftDet.end_datetime,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                                            arrDt = endDTime.toString().split(' ');
                                            const endHHMM = arrDt[1];
                                            // STATUS UPDATED TIME REMOVED AS PER CLIENT REQUEST - 28Jan2025
                                            let statusUpdatedTime = '';
                                            // if(shiftDet.status_updated_time!==null && shiftDet.status_updated_time.length > 1){
                                            //     // CONVERTED DATA IS COMING FROM SERVER SO JUST SHOW IT 
                                            //     // arrDt = shiftDet.status_updated_time.toString().split('T');
                                            //     // arrDMY = arrDt[0].split('-');
                                            //     // statusUpdatedTime = arrDMY[2]+'/'+arrDMY[1]+'/'+arrDMY[0]+' '+arrDt[1].substring(0,5);
                                            //     statusUpdatedTime = converDateToLocal(shiftDet.actual_status_updated_time,"+00:00",'ddmmyyyyhhmm');  
                                            // } 
                                            let shiftLength = convertDecimalToHHMM(shiftDet.shift_length); 
                                            let shiftTitle = shiftDet.shift_title+' @ '+shiftDet.event_title;
                                            let titleDiv   = '';
                                            if(shiftTitle.length>40){
                                                let shortshiftTitle = shiftTitle.substring(0, 40)+'...';
                                                titleDiv = <OverlayTrigger
                                                placement="top"
                                                delay={{ show: 450, hide: 250 }}
                                                overlay={<Tooltip id='title-tooltip' style={{
                                                    opacity: 0.8,
                                                }}>
                                                {shiftTitle}
                                                </Tooltip>}
                                                >
                                                <span className="title-tooltip" id="titletip">                                            
                                                    {shortshiftTitle}   
                                                </span>
                                                </OverlayTrigger>
                                            }else{
                                                titleDiv = shiftTitle;
                                            }
                                            if(showShift===0) {
                                                return('');
                                            }
                                            else if(showShift > 0) {
                                                return(<div key={shiftDet.shift_id} className="maxWidth380 divFloatLeft paddingBottom5 padding-left-0">
                                                    <div  className="alert-box max-height-130">
                                                        <p className="mb-0"><Link to="#" onClick={(e) => this.showShiftDetail(shiftDet.shift_id)}><span className="change-count color-red text-bold ">{shiftDet.special_shift?"! ":""}</span>{titleDiv}</Link>
                                                        </p>
                                                        <p className="mb-2">
                                                        <span className="font-13"> {startHHMM}  - {endHHMM} ({shiftLength+' '+LBL_HOURS_SHORT.toLowerCase()})</span> 
                                                        </p> 
                                                        <div className="crew-block date-view-block">  
                                                            <div className="shift-module__list">
                                                                <span className="crew-txt">{LBL_TOTAL}: <b>{shiftDet.required}</b></span>   
                                                            </div>                                             
                                                            <div className="shift-module__list">
                                                                <span className="crew-txt">{LBL_CONFIRMED}: <b>{(parseInt(shiftDet.required,10)-parseInt(shiftDet.pending,10))}</b></span>
                                                                <span className="crew-txt">{LBL_REQUESTED}: <b>{shiftDet.requested}</b></span>
                                                                <span className={shiftDet.pending>0?'crew-txt crew-txt--pending':'crew-txt'}>{LBL_REQUIRED}: <b>{shiftDet.pending}</b></span>
                                                            </div>
                                                        </div> 
                                                        <ul className="row flexDisp col-12">
                                                            <li className={"status "+shiftStatus[0].colorClass+" col-12 p-0 "}>
                                                            <small className="status-fill">{shiftStatus[0].statusString}</small>
                                                            {statusUpdatedTime!=='' &&
                                                            <span className="updated-date font-13">{LBL_ON+' '+statusUpdatedTime}</span>
                                                            }
                                                            </li>                    
                                                        </ul>
                                                    </div>
                                                </div>
                                                )
                                            }
                                        })
                                        }
                                    </div>   
                                </div> 
                                }

                           </div>
                        </div>
                        </>
                        }                




                        {dataViewType==='crew' && 
                        <>
                        {scheduleData_Crew_Rows.length > 0 && scheduleData_Crew_Rows.map((crewItem, index) => {

                            let imageClass = crewItem.crew_chief_eligibility?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';
                            let profileImgTag = '';
                            if(crewItem.crew_profile_id!=='blank') { 
                                profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'profile-image.png')} alt={crewItem.crew_name} title={crewItem.crew_name} />; 
                                if ((crewItem.crew_profile_image) && crewItem.crew_profile_image.trim().length > 0){
                                    profileImgTag = <img className={imageClass} src={crewItem.crew_profile_image} alt={crewItem.crew_name} title={crewItem.crew_name} />;
                                }
                                else if(((!crewItem.crew_profile_image) || crewItem.crew_profile_image.trim().length===0) && crewItem.avatar_name && crewItem.avatar_name.trim().length > 0) {
                                    profileImgTag = <span title={crewItem.crew_name} className={crewItem.crew_chief_eligibility?'center-align img-fluid img-prof-small img-avatar img-crew-chief':'center-align img-fluid img-prof-small img-avatar'} style={{ background:crewItem.profile_color}}>{crewItem.avatar_name} </span>; 
                                }
                            }

                            let crewFullName = crewItem.crew_name; 
                            let crewShortName = crewItem.crew_name.length > 15 ? crewItem.crew_name.substr(0,15)+'...' : crewItem.crew_name; 
                            let crewName = crewFullName!==crewShortName ? <OverlayTrigger placement="top"
                            delay={{ show: 450, hide: 250 }} overlay={<Tooltip id='title-tooltip' style={{
                                opacity: 0.8,
                            }}> {crewFullName} </Tooltip>}
                            >
                            <span className="title-tooltip" id="titletip"> {crewShortName} </span>
                            </OverlayTrigger> : crewFullName;

                            let plFullName = crewItem.pay_level_name; 
                            let plShortName = crewItem.pay_level_name.length > 15 ? crewItem.pay_level_name.substr(0,15)+'...' : crewItem.pay_level_name; 
                            let payLevel = plFullName!==plShortName ? <OverlayTrigger placement="top"
                            delay={{ show: 450, hide: 250 }} overlay={<Tooltip id='title-tooltip' style={{
                                opacity: 0.8,
                            }}> {plFullName} </Tooltip>}
                            >
                            <span className="title-tooltip" id="titletip"> {plShortName} </span>
                            </OverlayTrigger> : plFullName;


                            return(
                            <div  key={'crewView_'+index} className="row">
                                <div className="max-width-255 max-height-90 ">
                                    <div className="date-info-crew text-center crew padding-top-15">
                                    {crewItem.crew_profile_id!=='blank' && <div className="crew__aside float-left">
                                        <div className="crew__thumb">
                                            {profileImgTag}
                                        </div>
                                        <span className="crew__badge">{crewItem.crew_omnu_points}</span>                                       
                                    </div>}
                                    <div className="float-left padding-left-5">
                                    <p className="mb-0 mt-2 padding-left-10">{crewName}</p>
                                    <small className="float-left padding-left-10">{payLevel}</small></div>
                                    </div>
                                    
                                    {crewItem.crew_profile_id==='blank' && <div className="text-center">
                                        <p>&nbsp;</p>
                                    </div>}
                                </div>


                                <div className="padding-left-5 divFloatLeft paddingBottom5 flex-1">
                                    {crewItem.schedules.map((shiftDet, index) => { 
                                    const shiftStatus = SCHEDULE_CREW_STATUS.filter(x => Number(x.statusCode) ===Number(shiftDet.schedule_status));
                                    
                                    const startHHMM = converDateToLocal(shiftDet.start_datetime,timeZone.utc_offset,'ddmmyyyyhhmm');
                                    const endHHMM = converDateToLocal(shiftDet.end_datetime,timeZone.utc_offset,'hhmm');
                                    let statusUpdatedTime = '';
                                    // STATUS UPDATED TIME REMOVED AS PER CLIENT REQUEST - 28Jan2025
                                    // if(shiftDet.status_updated_time!==null){
                                    //     statusUpdatedTime = converDateToLocal(shiftDet.status_updated_time,"+00:00",'ddmmyyyyhhmm');
                                    // }
                                    let strLen = 12; 
                                    let shiftTitle = shiftDet.shift_title+' @ '+shiftDet.event_title;
                                    let shortshiftTitle = shiftDet.shift_title.length > strLen ? (shiftDet.shift_title.substring(0, strLen)+'...') : shiftDet.shift_title; 
                                    shortshiftTitle += ' @ '; 
                                    shortshiftTitle += shiftDet.event_title.length > strLen ? (shiftDet.event_title.substring(0, strLen)+'...') : shiftDet.event_title; 
                                    let titleDiv   = '';
                                    if(shiftTitle.length>0){ // USE THIS AS DEFAULT 
                                        // let shortshiftTitle = shiftTitle.substring(0, 40)+'...';
                                        titleDiv = <OverlayTrigger
                                        placement="top"
                                        delay={{ show: 450, hide: 250 }}
                                        overlay={<Tooltip id='title-tooltip' style={{
                                            opacity: 0.8,
                                        }}>
                                        {shiftTitle}
                                        </Tooltip>}
                                        >
                                        <span className="title-tooltip" id="titletip">                                            
                                               {shortshiftTitle}                                            
                                        </span>
                                        </OverlayTrigger>
                                    }else{
                                        // titleDiv = shiftTitle;
                                        titleDiv = shiftDet.shift_title.length > strLen ? (shiftDet.shift_title.substring(0, strLen)+'...') : shiftDet.shift_title; 
                                        titleDiv += ' @ ';
                                        titleDiv += shiftDet.event_title.length > strLen ? (shiftDet.event_title.substring(0, strLen)+'...') : shiftDet.event_title; 
                                    }
                                    let shiftLength = convertDecimalToHHMM(shiftDet.shift_length);
                                    return(<div key={index+'_'+shiftDet.shift_id} className="max-width-300 divFloatLeft padding-left-0 paddingBottom5">
                                        <div className="alert-box max-height-90">
                                            <p className="mb-0">{shiftDet.is_crew_chief && <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span>}{shiftDet.vehicle_added === true && <span className="chief-icon background-black"><img className="car-image" src={require('../../'+URL_IMG+'car_filled.svg')} alt="Action" /></span>}<Link to="#" onClick={(e) => this.showShiftDetail(shiftDet.shift_id)}><span className="change-count color-red text-bold ">{shiftDet.special_shift?"! ":""}</span>{titleDiv}</Link></p>
                                            <div className=""><span className="font-12">{startHHMM}  - {endHHMM} ({shiftLength+' '+LBL_HOURS_SHORT.toLowerCase()})</span></div>

                                            <div className={shiftStatus[0].colorClass+' col-12 p-0'}><small className="status-fill">{shiftStatus[0].statusString} </small>{statusUpdatedTime!=='' &&
                                                    <span className="padding-left-5 text-black"><small>{LBL_ON+' '+statusUpdatedTime}
                                                    </small></span>}</div>

                                            {/* <ul className="row">
                                                <li className={"status "+shiftStatus[0].colorClass+" col-12 p-0"}>
                                                    <small><i className="fas fa-circle"></i></small> {shiftStatus[0].statusString}
                                                    {statusUpdatedTime!=='' &&
                                                    <span className="updated-date font-13">{LBL_ON+' '+statusUpdatedTime}
                                                    </span>}
                                                </li>                                               
                                            </ul> */}
                                        </div>
                                    </div>)})}
                                </div>  
                            </div>)  
                            })}
                            </> 
                        }   


                        {/* { ((dataViewType==='date' && dateView_hasMore) || (dataViewType==='crew' && hasMore)) && 
                        <div className="col-12 hasMoreNotifications" >
                            <Link to="#" onClick={this.loadNextPage} >{LBL_VIEW_MORE}</Link>
                        </div>
                        }                 */}

                    </div> 
               </div>
            </div>
            
            <Filter isDetail={true} onResetFiltersButton={this.onResetFiltersButton} onApplyFilterButton={this.onApplyFilterButton} >
                
                <FilterScheduleView filterClicked={this.state.filterClicked} resetFilterClicked={this.state.resetFilterClicked} onApplyFilterButton={this.onApplyFilterButton} applyFilterClicked={this.state.applyFilterClicked} applyFilters={this.applyFilters} dataViewType={this.state.dataViewType} changeTabState={this.changeTabState} tabSwitch={this.state.tabSwitch} tabCurrentlySwitched={this.state.tabCurrentlySwitched} changeTabSwitchedStatus={this.changeTabSwitchedStatus} tabSwitchingStatus={this.state.tabSwitchingStatus} tabSwitchCompleted={this.tabSwitchCompleted} /> 

                <ShiftDetailSlider location={this.props.location} {...this.state} hideEditDeleteAction='1'  calledFrom='ScheduleView' loadEventSchedule={this.loadEventSchedule} />
            </Filter>
        </React.Fragment>
    )
    }
}

const mapStateToProps = (state) => { 
    return {
        status: state.event.status, 
        activity: state.event.activity,
        subactivity: state.event.subactivity, 
        scheduleDateViewData: state.event.scheduleDateViewData, 
        scheduleCrewViewData: state.event.scheduleCrewViewData,
        errorData: state.event.errorData,
        schedDateViewCalendarData: state.event.schedDateViewCalendarData,
        schedDateViewCalDateData: state.event.schedDateViewCalDateData, 
        isFilterOn: state.commons.isFilterOn,
        isFromReport: state.commons.fromReport,
        serverTimeList: state.serverTimeList.serverTimeList,
        serverTimeListActivity : state.serverTimeList.serverTimeListActivity
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        schedulesDateViewCalendarAction: schedulesDateViewCalendarAction,
        scheduleCrewViewAction: scheduleCrewViewAction, 
        sendShiftIdsForScheduleAction:sendShiftIdsForScheduleAction,
        clearAction:clearAction,
        scheduleSetHeaderFromToDateAction: scheduleSetHeaderFromToDateAction,
        schedDateViewCalendarDateAction:schedDateViewCalendarDateAction,
        serverTimeAction:serverTimeAction,
        aflt_departmentsListAction:aflt_departmentsListAction,
        fromReport:fromReport
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(ScheduleView);